export type ColorsType = {
  // Design system colors
  neutral100: string;
  neutral200: string;
  neutral300: string;
  neutral400: string;
  neutral500: string;
  neutral600: string;
  neutral700: string;
  neutral800: string;
  neutral900: string;
  neutral1000: string;

  // Primary
  primary100: string;
  primary200: string;
  primary300: string;
  primary400: string;
  primary500: string;
  primary600: string;
  primary700: string;
  primary800: string;
  primary900: string;
  primary1000: string;

  // Secondary
  secondary100: string;
  secondary200: string;
  secondary300: string;
  secondary400: string;
  secondary500: string;
  secondary600: string;
  secondary700: string;
  secondary800: string;
  secondary900: string;
  secondary1000: string;

  // Tertiary
  tertiary100: string;
  tertiary200: string;
  tertiary300: string;
  tertiary400: string;
  tertiary500: string;
  tertiary600: string;
  tertiary700: string;
  tertiary800: string;
  tertiary900: string;
  tertiary1000: string;

  // Success
  success100: string;
  success200: string;
  success300: string;
  success400: string;
  success500: string;

  // Alert
  alert100: string;
  alert200: string;
  alert300: string;
  alert400: string;
  alert500: string;

  // Warning
  warning100: string;
  warning200: string;
  warning300: string;
  warning400: string;
  warning500: string;

  // Info
  info100: string;
  info200: string;
  info300: string;
  info400: string;
  info500: string;

  // Skeletons
  skeletonLightBG: string;
  skeletonDarkBG: string;

  // Gray
  gray600: string;
  gray700: string;
  gray300: string;

  // Box Shadows
  boxShadowLigh: string;
  credentialShadow: string;
  buttonsPurpleShadow: string;
  buttonsTealShadow: string;
  buttonsRedShadow: string;
  buttonsYellowShadow: string;
  buttonsBlueShadow: string;
  buttonsGreenShadow: string;
  buttonsBlackShadow: string;
  buttonsWhiteShadow: string;
  buttonsGreyShadow: string;
};

export const colorsByLabel: Record<string, ColorsType> = {
  PRIMARY: {
    // Neutral
    neutral100: '#ffffff',
    neutral200: '#f2f2f2',
    neutral300: '#e4e4e4',
    neutral400: '#c6c6c8',
    neutral500: '#a9a9ac',
    neutral600: '#8c8c90',
    neutral700: '#707074',
    neutral800: '#545458',
    neutral900: '#39393c',
    neutral1000: '#1e1e20',

    // Primary
    primary100: '#f2f2ff',
    primary200: '#DEDEFB',
    primary300: '#CCCBF8',
    primary400: '#A5A4E8',
    primary500: '#8281D7',
    primary600: '#6361C7',
    primary700: '#4745B7',
    primary800: '#2F2D8B',
    primary900: '#1B1A5F',
    primary1000: '#0C0B33',

    // Secondary
    secondary100: '#E8FEFF',
    secondary200: '#BBF2F4',
    secondary300: '#8EE6E9',
    secondary400: '#54CCD0',
    secondary500: '#25B2B7',
    secondary600: '#00999E',
    secondary700: '#067A7E',
    secondary800: '#095C5E',
    secondary900: '#083D3E',
    secondary1000: '#061E1F',

    // Tertiary
    tertiary100: '#FFF2F6',
    tertiary200: '#FFD4E1',
    tertiary300: '#FFB6CD',
    tertiary400: '#F486A7',
    tertiary500: '#E85A84',
    tertiary600: '#DC3164',
    tertiary700: '#B22851',
    tertiary800: '#891E3E',
    tertiary900: '#5F152B',
    tertiary1000: '#360C18',

    // Success
    success100: '#D9FADF',
    success200: '#80CA8D',
    success300: '#3D9A4E',
    success400: '#186927',
    success500: '#04380E',

    // Alert
    alert100: '#FFDEDF',
    alert200: '#EE888C',
    alert300: '#DC3D43',
    alert400: '#8D1A1E',
    alert500: '#3D0608',

    // Warning
    warning100: '#FFF6CA',
    warning200: '#FBE263',
    warning300: '#F7CE00',
    warning400: '#B99B08',
    warning500: '#7A680B',

    // Info
    info100: '#E4F3FF',
    info200: '#6FB8F8',
    info300: '#0081F1',
    info400: '#07549A',
    info500: '#062542',

    // Skeletons
    skeletonLightBG: '#e0e0e0',
    skeletonDarkBG: '#c6c6c6d1',

    // Gray
    gray600: '#757575',
    gray700: '#707074',
    gray300: '#E4E4E4',

    // Box Shadows
    boxShadowLigh: 'rgba(12, 11, 51, 0.12)',
    credentialShadow: '#0E0E361A',
    buttonsPurpleShadow: 'rgba(71, 69, 183, 0.60)',
    buttonsTealShadow: 'rgba(0, 153, 158, 0.60)',
    buttonsRedShadow: 'rgba(220, 61, 67, 0.60)',
    buttonsYellowShadow: 'rgba(247, 206, 0, 0.60)',
    buttonsBlueShadow: 'rgba(0, 129, 241, 0.60)',
    buttonsGreenShadow: 'rgba(61, 154, 78, 0.60)',
    buttonsBlackShadow: 'rgba(30, 30, 32, 0.60)',
    buttonsWhiteShadow: 'rgba(255, 255, 255, 0.60)',
    buttonsGreyShadow: 'rgba(169, 169, 172, 0.60)',
  },
  SECONDARY: {
    // Neutral
    neutral100: '#ffffff',
    neutral200: '#f2f2f2',
    neutral300: '#e4e4e4',
    neutral400: '#c6c6c8',
    neutral500: '#a9a9ac',
    neutral600: '#8c8c90',
    neutral700: '#707074',
    neutral800: '#545458',
    neutral900: '#39393c',
    neutral1000: '#001019',

    // Primary
    primary100: '#E6F6FF',
    primary200: '#C9E9FB',
    primary300: '#A9DBF7',
    primary400: '#86CCF3',
    primary500: '#5FBBEF',
    primary600: '#32A8EB',
    primary700: '#0094E7',
    primary800: '#0073B3',
    primary900: '#005180',
    primary1000: '#00304D',

    // Secondary
    secondary100: '#E6F6FF',
    secondary200: '#A7D0E8',
    secondary300: '#70ADD0',
    secondary400: '#438EB9',
    secondary500: '#1D71A1',
    secondary600: '#00588A',
    secondary700: '#03476E',
    secondary800: '#043552',
    secondary900: '#042336',
    secondary1000: '#031119',

    // Tertiary
    tertiary100: '#FFF2F6',
    tertiary200: '#FFD4E1',
    tertiary300: '#FFB6CD',
    tertiary400: '#F486A7',
    tertiary500: '#E85A84',
    tertiary600: '#DC3164',
    tertiary700: '#B22851',
    tertiary800: '#891E3E',
    tertiary900: '#5F152B',
    tertiary1000: '#360C18',

    // Success
    success100: '#D9FADF',
    success200: '#80CA8D',
    success300: '#3D9A4E',
    success400: '#186927',
    success500: '#04380E',

    // Alert
    alert100: '#FFDEDF',
    alert200: '#EE888C',
    alert300: '#DC3D43',
    alert400: '#8D1A1E',
    alert500: '#3D0608',

    // Warning
    warning100: '#FFF6CA',
    warning200: '#FBE263',
    warning300: '#F7CE00',
    warning400: '#B99B08',
    warning500: '#7A680B',

    // Info
    info100: '#E4F3FF',
    info200: '#6FB8F8',
    info300: '#0081F1',
    info400: '#07549A',
    info500: '#062542',

    // Skeletons
    skeletonLightBG: '#e0e0e0',
    skeletonDarkBG: '#c6c6c6d1',

    // Grey
    gray600: '#757575',
    gray700: '#707074',
    gray300: '#E4E4E4',

    // Box Shadows
    boxShadowLigh: 'rgba(12, 11, 51, 0.12)',
    credentialShadow: '#0E0E361A',
    buttonsPurpleShadow: 'transparent',
    buttonsTealShadow: 'transparent',
    buttonsRedShadow: 'transparent',
    buttonsYellowShadow: 'transparent',
    buttonsBlueShadow: 'transparent',
    buttonsGreenShadow: 'transparent',
    buttonsBlackShadow: 'transparent',
    buttonsWhiteShadow: 'transparent',
    buttonsGreyShadow: 'transparent',
  },
};
